import styles from "./styles.module.css";
import { MdAdd } from "react-icons/md";
import { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { DatabaseValue } from "../../../../contexts/database";
import { UserValue } from "../../../../contexts/user";
import { db } from "../../../../firebase";
import { createRow, deleteRow } from "../../../../utils/databaseactions";
import useAdminRequest from "../../../../utils/useadminrequest";
import Rule from "./rule";

export default function Security({ id, open }) {
  const { appId } = useParams();
  const tables = useContext(DatabaseValue);
  const user = useContext(UserValue);
  const table = tables[id];
  const adminRequest = useAdminRequest();
  const [rules, setRules] = useState([]);

  useEffect(() => {
    let unsub;
    if (table.id && appId) {
      unsub = db
        .collection("apps")
        .doc(appId)
        .collection("tables")
        .doc(table.id)
        .collection("securityRules")
        .orderBy("name")
        .onSnapshot((snap) => {
          const rules = snap.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          setRules(rules);
        });
    }
    return unsub;
  }, [appId, table.id]);

  const handleAdd = () => {
    const sr = {
      name: "new Security Rule",
      condition: {},
      fields: {},
      create: false,
      update: false,
      delete: false,
      table: table.id,
    };
    db.collection("apps")
      .doc(appId)
      .collection("tables")
      .doc(table.id)
      .collection("securityRules")
      .add(sr)
      .then(async (docRef) => {
        const doc = await docRef.get();
        const _rule = {
          _id: doc.id,
          table: table.id,
          ...doc.data(),
        };
        delete _rule.name;
        await createRow(appId, "rules", _rule, user);
      })
      .catch((err) => console.log(err));
  };

  const saveToDB = async (rule) => {
    await adminRequest.post("/connection", { api: rule });
  };

  const handleUpdate = (rule) => {
    db.collection("apps")
      .doc(appId)
      .collection("tables")
      .doc(table.id)
      .collection("securityRules")
      .doc(rule.id)
      .set({ ...rule })
      .then(async () => {
        await saveToDB(rule);
      })
      .catch((err) => console.log(err));
  };

  const handleDelete = (rule) => {
    db.collection("apps")
      .doc(appId)
      .collection("tables")
      .doc(table.id)
      .collection("securityRules")
      .doc(rule.id)
      .delete()
      .then(async () => {
        await adminRequest.delete("/connection/" + rule.id);
      })
      .catch((err) => console.log(err));
  };

  if (!open) {
    return null;
  }

  return (
    <div className={styles.security}>
      <div className={styles.title}>Security Rules</div>
      {rules.map((r, i) => {
        return (
          <Rule
            onChange={handleUpdate}
            onDelete={handleDelete}
            rule={r}
            key={r.id}
            table={table}
          />
        );
      })}
      <div onClick={handleAdd} className={styles.add}>
        <MdAdd />
        ADD
      </div>
    </div>
  );
}
